class Element {
  constructor() {
    this.listeners = {};
  }

  mount(el) {
    if (typeof el === 'string') {
      el = document.querySelector(el)[0];
    }

    el.innerHTML = `
      <div id='stripe-elements'>
        <p>Click to simulate filling in Stripe Elements</p>
      </div>
    `;

    const changed = () => {
      (this.listeners['change'] || []).forEach((handler) =>
        handler({ complete: true })
      );
    };

    document
      .querySelector('#stripe-elements')
      .addEventListener('click', changed, false);
  }

  on(event, handler) {
    this.listeners[event] = this.listeners[event] || [];
    this.listeners[event].push(handler);
  }

  update() {}

  destroy() {}
}

const fakeStripe = () => ({
  elements: () => ({
    create: () => new Element(),
  }),

  handleCardSetup: () =>
    new Promise((resolve) => {
      if (window.StripeTestData.returnCardSetupError) {
        resolve({
          error: {
            code: 'card_declined',
            message: 'Your card was declined.',
          },
        });
      } else {
        resolve({});
      }
    }),

  handleCardPayment: () =>
    new Promise((resolve) => {
      resolve(window.StripeTestData.handleCardPaymentResponse);
    }),

  paymentRequest: (config) => {
    window.stripePaymentRequestLabelForSystemSpecs = config.total.label;

    return {
      canMakePayment: () =>
        new Promise((resolve) => {
          resolve({ applePay: window.enableApplePay });
        }),
      on: (event, handler) => {
        document
          .querySelector('.express-donate-button')
          .addEventListener(event, handler);
      },
      show: () => {
        const event = new CustomEvent('paymentmethod');

        event.complete = () => {
          class InvalidAccessError extends Error {
            constructor(...params) {
              super(...params);
              this.name = 'InvalidAccessError';
            }
          }

          if (window.StripeTestData.raiseInvalidAccessError) {
            throw new InvalidAccessError();
          }
        };
        event.paymentMethod = { id: 'pi_stubbed_payment_method' };
        event.payerName = window.StripeTestData.payerName;
        event.payerEmail = window.StripeTestData.payerEmail;

        setTimeout(
          () =>
            document
              .querySelector('.express-donate-button')
              .dispatchEvent(event),
          1000
        );
      },
    };
  },
});

export default fakeStripe;
